import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { attrGroupLinkedTables } from "components/PimDashboard/data";
import { useMemo, useState } from "react";

const CarryForwardModal = ({ open, onClose, selectedStyle, seasonOptions, onSubmit, loading = false }) => {
	const currentSeason = selectedStyle?.[attrGroupLinkedTables.style.key]?.season ?? "";
	const [season, setSeason] = useState("");

	const availableSeasons = useMemo(
		() => (seasonOptions ?? []).filter((option) => option !== currentSeason),
		[seasonOptions, currentSeason],
	);

	const handleClose = () => {
		setSeason("");
		onClose();
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!season) return;
		onSubmit({ season }, handleClose);
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" component="form" onSubmit={handleSubmit}>
			<DialogTitle>Carry Forward Style</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Select a new season. The style will be unpublished, order type will be set to Carry Forward, and colors will
					move back to Designer Pending.
				</Typography>
				<Box pt={1}>
					<FormControl fullWidth required>
						<InputLabel id="carry-forward-season-label">New Season</InputLabel>
						<Select
							labelId="carry-forward-season-label"
							label="New Season"
							value={season}
							onChange={(e) => setSeason(e.target.value)}>
							{availableSeasons.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={handleClose} disabled={loading}>
					Cancel
				</Button>
				<Button type="submit" variant="contained" disabled={!season || loading}>
					Confirm Carry Forward
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CarryForwardModal;
